import { render, staticRenderFns } from "./DangerousToHealthModal.vue?vue&type=template&id=63537526&scoped=true&"
import script from "./DangerousToHealthModal.vue?vue&type=script&lang=ts&"
export * from "./DangerousToHealthModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63537526",
  null
  
)

export default component.exports